import * as TypeStyle from 'typestyle';
import {
  InteractiveBorderColors, InvertInteractiveBorderColors, InvertTextColors, TextColors, TextFieldHoverColor, TextFieldBorderColors
} from '../../styles/Colors';
import { DefaultFocusIndicator, ErrorFocusIndicator, InvertFocusIndicator, ValidFocusIndicator } from '../../styles/FocusIndicators';
import { PreventUserSelect } from '../../styles/PreventUserSelect';

const ButtonHeight = 24;
export const BorderWidth = 1;

export const ChildrenClassName = TypeStyle.style({
  alignItems: 'center', // vertically align to center of container
  alignSelf: 'stretch', // fill the container height
  display: 'inline-flex',
  flexGrow: 1,
  minHeight: ButtonHeight - BorderWidth * 2,
  overflow: 'hidden',
  padding: '0 7px',
  $nest: {
    '.icon > &': { flexGrow: 0, padding: 0 },
  }
});

export const ClassName = TypeStyle.style(PreventUserSelect, {
  alignItems: 'center',
  backgroundColor: 'transparent', // override UA default
  border: `${BorderWidth}px solid transparent`,
  borderRadius: 1,
  boxSizing: 'border-box',
  color: TextColors.Primary,
  display: 'flex',
  fontFamily: 'inherit',
  fontSize: 12,
  lineHeight: 'normal',
  outline: 'none',
  padding: 0,
  position: 'relative',

  $nest: {
    '&.outline': InteractiveBorderColors,
    '&.line': InteractiveBorderColors,
    '&&&.line': {
      borderLeftColor: 'transparent', borderRightColor: 'transparent', borderTopColor: 'transparent',
      borderBottomLeftRadius: 0, borderBottomRightRadius: 0,
    },
    '&.text, &.icon': {
      display: 'inline-flex',
    },
    '&.text:enabled, &.icon:enabled': {
      cursor: 'pointer',
    },

    '&:hover:enabled:not(:focus)': { backgroundColor: TextFieldHoverColor },
    '&&&:active:enabled': { backgroundColor: '#ebebeb', borderColor: TextFieldBorderColors.Hover },
    '&&&&:focus': DefaultFocusIndicator,

    '.valid > &': {
      color: TextColors.Valid,
      $nest: {
        '&.outline, &.line': { borderColor: ValidFocusIndicator.borderColor },
        '&&&:focus': ValidFocusIndicator,
      }
    },

    '&[aria-invalid="true"]': {
      color: TextColors.Error,
      $nest: {
        '&.outline, &.line': { borderColor: ErrorFocusIndicator.borderColor },
        '&&&:focus': ErrorFocusIndicator,
      }
    },

    '.dark > &': {
      backgroundColor: 'transparent !important',
      color: InvertTextColors.Primary,
    },
    '.dark > &.outline': InvertInteractiveBorderColors,
    '.dark > &.line': InvertInteractiveBorderColors,
    '.dark > &&&:focus': InvertFocusIndicator,
  }
});

export const PopupContainerStyle: React.CSSProperties = Object.freeze({
  position: 'absolute',
});
